import React from "react";
import ValueCard from "./ValueCard";
import { getValuePropositionCards } from "./valuePropositionData";
import { useLanguage } from "@/context/LanguageContext";

const ValueCardsGrid = () => {
  const { language } = useLanguage();
  const valuePropositionCards = getValuePropositionCards(language);

  return (
    <div className="max-w-4xl mx-auto">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {valuePropositionCards.map((card) => (
          <ValueCard key={card.id} card={card} />
        ))}
      </div>
    </div>
  );
};

export default ValueCardsGrid;
